import { render, staticRenderFns } from "./Deltalisted.vue?vue&type=template&id=c32f6828"
import script from "./Deltalisted.vue?vue&type=script&lang=js"
export * from "./Deltalisted.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports